import {validDateKey,shiftDate} from './activity-model.js';
import {routeRange} from './route-range.js';

// Selecting the same day twice is an inclusive one-day period.
export function selectRangeDate(anchor,day,today){
 if(!validDateKey(day)||day>today)return {anchor,error:'invalid'};
 if(!anchor)return {anchor:day};
 const [start,end]=[anchor,day].sort();
 if(!routeRange(start,end))return {anchor,error:'too-long'};
 return {start,end,anchor:null};
}
export function shiftDateRange(start,end,direction){
 if(!routeRange(start,end)||![1,-1].includes(direction))return null;
 const days=Math.round((Date.parse(end)-Date.parse(start))/86400000)+1;
 return {start:shiftDate(start,days*direction),end:shiftDate(end,days*direction)};
}
